import { useSelector } from 'react-redux'
import styled from 'styled-components'
import PageTopTitle from '../../components/shared/PageTopTitle'
import Btn from '../../components/shared/button/Btn'
import { gibLogoutPortal } from '../../features/e-Arsiv/eArsivSlice'
import { useDispatch } from 'react-redux'
import { showModal } from '../../features/modal/modalSlice'
import SmallSpinner from '../../components/shared/spinners/SmallSpinner'


const Container = styled.div`
  width: 100%;
  height: 100%;
    .wrapper{
      width: 700px;
      padding: 30px;
      .content{

        p{
          width: 200px;
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
        }
        span{
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
        }
        .row{
            width: 100%;
            margin-block: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            &:hover{
              background-color: ${({theme}) => theme.mainBgColor};
            }
        }
      }
    }


@media (max-width: 850px){
  .wrapper{
    width: 100% !important;
    .row{
      flex-direction: column;
      justify-content: flex-start !important;
      align-items: flex-start !important;
    }
    p{
      width: auto !important;
    }
  }
}
`
const EArsivGibHesabi = () => {
  const dispatch = useDispatch()
  const {theme} = useSelector((state) => state.layout)
  const {gibAccountInfo, isLoadingGibLogout} = useSelector((state) => state.eArsiv)


  // useEffect(() => {
  //   dispatch(setGibAccountInfo({
  //     gibTaxName: JSON.parse(localStorage.getItem("gibTaxName")),
  //     gibTaxOffice: JSON.parse(localStorage.getItem("gibTaxOffice")), 
  //     gibVknTckn: JSON.parse(localStorage.getItem("gibVknTckn")),
  //     token: JSON.parse(localStorage.getItem("gibToken")),
  //     callId: JSON.parse(localStorage.getItem("gibCallId")),
  //     callIdCount: JSON.parse(localStorage.getItem("gibCallIdCount"))
  //   }))
  // }, [])


  const handleLogout = () => {
    dispatch(gibLogoutPortal({
      authInfoDto: {"token": gibAccountInfo?.gibToken, "callId": gibAccountInfo?.gibCallId, callIdCount: gibAccountInfo?.gibCallIdCount}
    }))
  }
  return (
    <Container theme={theme}>
        <PageTopTitle title={"GİB Hesabı"} position='sticky' top='210px'/>

        <div className="wrapper">
            <div className="content">
              <h3>GİB Hesap Bilgileri</h3>
              <div className="row">
                <p>Şirket Adı:</p>
                <span>{gibAccountInfo.gibTaxName}</span>
              </div>
              <div className="row">
                <p>Vergi Dairesi:</p>
                <span>{gibAccountInfo.gibTaxOffice}</span>
              </div>
              <div className="row">
                <p>Vergi No / TC No:</p>
                <span>{gibAccountInfo.gibVknTckn}</span>
              </div>

              {
                gibAccountInfo.gibTaxName ? 
                <Btn color='#E85446' bgColor='transparent' padding='10px' width={"150px"} handleClick={handleLogout}>{isLoadingGibLogout ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"} /> : "Çıkış Yap" }</Btn>
                :
                <Btn color='#E85446' bgColor='transparent' padding='10px' width={"150px"} handleClick={() => dispatch(showModal("gibLogin"))}>Giriş Yap</Btn>
              }

            </div>
        </div>
    </Container>
  )
}

export default EArsivGibHesabi